(function() { window.GUID_8e842459_01fb_4c3b_a071_62d4485887ba = { getGuid: function() { return "8e842459-01fb-4c3b-a071-62d4485887ba"; } }; })();
var CS;
(function (CS) {
    var lagNames = {}; //Dictionary<string, number>
    /**
     * Ajoute un délais à un call. Si vous l'appelez 2 fois avec le même 'uniqueName', seulement le 2e seras executé. Retourne le TimerHandle; peut être annulé avec 'clearTimeout(TimerHandle)'.
     * @param uniqueName
     * doit être unique à travers l'application. Utilisez quelque chose comme {Page}-{Method}-Autre
     * @param lagTime
     * temps en ms
     * @param callback
     * call ce callback après le lagTime
     */
    function Lag(uniqueName, lagTime, callback) {
        if (!uniqueName) {
            console.error("uniqueName is required");
            return;
        }
        let localTimeOutId = lagNames[uniqueName];
        clearTimeout(localTimeOutId);
        localTimeOutId = window.setTimeout(callback, lagTime);
        lagNames[uniqueName] = localTimeOutId;
        return localTimeOutId;
    }
    CS.Lag = Lag;
})(CS || (CS = {}));

//# sourceMappingURL=cs-lag.js.map
